import Component from 'core/Component';
import { deepMerge } from 'toolbox/deepMerge';
import { on, off } from 'toolbox/event';

/**
 * This is a description of the ProductExpiry constructor function.
 * @class
 * @classdesc To update product expiry date on PDP page if variation/swatch changed.
 * @extends Component
 */
export default class ProductExpiry extends Component {
    /**
     * Constructor of the class that mainly merge the options of the components
     * @param {HTMLElement} element HTMLElement of the component
     * @param {object} options options that belongs to the component
     */
    constructor(element, options = {}) {
        super(element, deepMerge({
            // Your custom options goes here
        }, options));
    }

    /**
     * All selectors must be cached. Never cache elements that are out of the component scope
     */
    initCache() {
        this.selectors.productExpiryDate = document.querySelector('.product-expiry-date');
    }

    /**
     * Should contain only event listeners and nothing else
     * All the event handlers should be into a separated function. No usage of anonyous function
     */
    bindEvents() {
        on('product.updated', this.element, this.onProductUpdated.bind(this), { customEvent: true });
    }

    /**
     * Update product expiration date if variation has changed.
     * @param {Object} e - event data
     */
    onProductUpdated(e) {
        if (e.detail.data && e.detail.data.productexpiry
            && e.detail.data.productexpiry.content && e.detail.data.productexpiry.content.productExpiryDates) {
            this.selectors.productExpiryDate.innerHTML = e.detail.data.productexpiry.content.productExpiryDates;
        }
    }

    /**
     * Destroy is called automatically after the component is being removed from the DOM
     * You must always destroy the listeners attached to an element to avoid any memory leaks
     */
    destroy() {
        off('product.updated', this.element);
    }
}
